$(window).on('load', function() {

  // Yotpo Reviews Wording
  setTimeout( () => {
    if ( $('.yotpo-no-reviews').length == 0 ) {
      let linkText = $('.yotpo.bottomLine .yotpo-bottomline.star-clickable a').text()
      $('.yotpo.bottomLine .yotpo-bottomline.star-clickable a').text(`READ ${linkText}`)
    }
    $('.yotpo.bottomLine').css('opacity', '1')
  }, 200)
});
